// extracted by mini-css-extract-plugin
export default {"crossSiteLabel":"I5-z","vrsnlCrossSiteLabel":"J5-z"};